import React from 'react';
import Card from './Card';

const GridCard = ({ gridItem }) => (
    <Card className="mb-4">
        <p className="text-lg font-semibold">{gridItem.title}</p>
    </Card>
);

export default GridCard;